  
import { Dynamic } from "../../../../../controllers/conductor";
import { getController } from "../../../../../controllers/getter";
import { MainWindow } from "../../../MainWindow";

import "../../../../../styles/forms.css";
import { IconButton } from "../../../../widgets/buttons";
import { getMonthName, parseDateWithTime } from "../../../../../misc/date";
import { ScrollingTable } from "../../../../widgets/table";

import React from "react";
import { Blocker } from "../../../../widgets/misc";
import { AlertDrawer } from "../../../../sections/sidebar/AlertDrawer";
import { MonthYearSelector } from "../../../../widgets/date_selector";
import { LoadingAnimation } from "../../../../widgets/loading";
import { SameDayProvinceSubmissionsController } from "../../../../../controllers/submissions/sameday/Province";
import { useParams } from "react-router-dom";
import { ApprovalIcon } from "../../../../widgets/approval";


function SameDayProvinceSubmissions() {

    const params = useParams();
    const ref = {
        province: params.provinceid,
        month: Number(params.month),
        year: Number(params.year)
    };

    const controller = getController(SameDayProvinceSubmissionsController, { ref });
    const { notifiers, status } = controller;
    if(controller.isInitialized) controller.changeDate(ref.month, ref.year);
    
    return (<MainWindow currentTab="forms" subtab="sameday">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller }) {
    return <div className="form-main">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <ListSection controller={controller}/>
        <Footer controller={controller} />
    </div>;
}


function Header({ controller }) {
    const { notifiers } = controller;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    return <Dynamic conductor={notifiers.reloaded} child={()=>{
        const data = controller.data;
        const provinceName = data.province.name + " Province";
        const date = getMonthName(data.month) + " " + data.year;
        const { month, year } = controller.reference;

        return <header>
            <div>
                <h2>Sameday Visit Submissions</h2>
                <h5>{ `${provinceName} • ${date}` }</h5>
            </div>
            <div className="buttons">
                <IconButton icon="refresh" onClick={() => controller.refresh()} />
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>;
    }} />;
}



function ListSection({ controller }) {
    const columns = [
        { title: "MUNICIPALITY / CITY", width: "30%" },
        { title: "SUBMISSION DATE", width: "25%" },
        { title: "PROVINCE", width: "15%" },
        { title: "REGION", width: "15%" },
        { title: "PUBLISHED", width: "15%" }
    ];

    const { notifiers, status } = controller;

    return <main>
        <Dynamic conductor={notifiers.reloaded} child={()=>{
            const { data } = controller;

            const rows = data.lgus.map((lgu) => {
                const { name, currentApproved } = lgu;

                const row = [ name, "-", "", "", "" ];

                if(currentApproved) {
                    const { submittedOn, approvals, published } = currentApproved;
                    row[1] = parseDateWithTime(submittedOn);
                    if(approvals.province.length > 0) row[2] = <ApprovalIcon key="1" />;
                    if(approvals.region.length > 0) row[3] = <ApprovalIcon key="2" />;
                    if(published) row[4] = <ApprovalIcon key="3" />;
                }

                return row;
            });

            const onRowClick = (rowIndex) => {
                const lgu = data.lgus[rowIndex];
                controller.viewLGUSubmissions(lgu.id);
            };

            return <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick} />;
        }} />
        <Dynamic conductor={notifiers.reloading} child={()=>
            <Blocker active={status.reloading}><center><LoadingAnimation />Loading data...</center></Blocker>
        } />
    </main>
}

function Footer({ controller }) {
    return <footer></footer>;
}



export default SameDayProvinceSubmissions;